import { Component, Renderer2, ElementRef, OnInit } from '@angular/core';
import { AppConfig } from '@shared/utils/app-config';

@Component({
    selector: 'feature-page-layout-google-maps',
    templateUrl: './google-maps.component.html',
    styleUrls: ['./google-maps.component.css'],
    standalone: false
})
export class GoogleMapsComponent implements OnInit {
  constructor(private appConfig: AppConfig, private renderer2: Renderer2, private el: ElementRef) {}

  ngOnInit(): void {
    const googleMapsApiKey = this.appConfig.googleMaps.apiKey;
    if (googleMapsApiKey) {
      const googleMapsScript = this.renderer2.createElement('script');
      googleMapsScript.async = true;
      googleMapsScript.type = 'text/javascript';
      googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&loading=async&libraries=places,marker`;
      this.renderer2.appendChild(this.el.nativeElement, googleMapsScript);
    }
  }
}
